import type { FacilityReview } from '@gyym/sdk'

import { sanitizeString } from '../sanitize'
import type { Review } from '../types'

/**
 * Convert date string to ISO 8601 format
 * "2025-04-18 22:07:51" -> "2025-04-18T22:07:51"
 */
const toIso8601 = (dateStr: string): string => {
  return dateStr.replace(' ', 'T')
}

/**
 * Build review array from facility reviews
 */
export const buildReviews = (reviews: FacilityReview[]): Review[] => {
  return reviews.map((review) => ({
    '@type': 'Review',
    name: sanitizeString(review.programName),
    author: {
      '@type': 'Person',
      name: `${review.age} / ${review.sex}`,
    },
    datePublished: toIso8601(review.postAt),
    reviewRating: {
      '@type': 'Rating',
      ratingValue: review.score,
      bestRating: 5,
      worstRating: 1,
    },
    reviewBody: sanitizeString(review.comment),
  }))
}
